import { Divider as MuiDivider, Grid } from "@yuno/design-system-web";

export const Divider = ({ children, ...props }) => (
  <Grid
    container
    alignItems="center"
    spacing={3}
    {...props}
    className="divider"
  >
    <Grid item xs>
      <MuiDivider  />
    </Grid>
    <Grid item>{children}</Grid>
    <Grid item xs>
      <MuiDivider />
    </Grid>
  </Grid>
);
